import { Table as MuiTable, TableBody } from "@mui/material";
import Header from "./header";
import Footer from "./footer";
import Verification from "./verification";
import { Verification as VerificationType } from "@/types/verification";
import FileViewer from "@/components/common/modals/file-viewer";
import { FileDescriptor } from "@/components/common/modals/file-viewer/context";

interface Props {
    attachmentsCache: React.MutableRefObject<Map<number, FileDescriptor>>;
    verifications: VerificationType[];
}

const Table: React.FC<Props> = ({ verifications, attachmentsCache }) => {
    return (
        <MuiTable>
            <Header />
            <TableBody>
                {verifications.map(verification => {
                    return (
                        <Verification
                            verification={verification}
                            attachmentsCache={attachmentsCache}
                            key={verification.id}
                        />
                    );
                })}

                <FileViewer />
            </TableBody>
            {verifications.length > 0 && (
                <Footer
                    endAmount={
                        (
                            verifications[verifications.length - 1] as VerificationType & {
                                endAmount: number;
                            }
                        ).endAmount
                    }
                />
            )}
        </MuiTable>
    );
};

export default Table;
